import { z } from 'zod';
import { IdSchema, IsoDateSchema } from './primitives.js';

export const FollowSchema = z.object({
  id: IdSchema,
  userId: IdSchema,
  targetType: z.enum(['artist', 'organizer']),
  targetId: IdSchema,
  createdAt: IsoDateSchema,
});

export const FollowCreateSchema = FollowSchema.omit({
  id: true,
  createdAt: true,
});

export type Follow = z.infer<typeof FollowSchema>;
export type FollowCreate = z.infer<typeof FollowCreateSchema>;
